import React from 'react';
import PropTypes from 'prop-types';
import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from 'firebase.js';
import { useSiteMetadata } from 'helpers';
import { useTeamColors } from 'hooks';
import {
  OverlayContainer,
  OnboardingContent,
  OnboardingTitle,
  OnboardingText,
  OnboardingButton,
} from './style';

export const OnboardingOverlay = ({ show, onComplete }) => {
  const analytics = getAnalyticsInstance();
  const { siteName } = useSiteMetadata();
  const { mainColor } = useTeamColors();

  const handleGetStarted = () => {
    if (analytics) {
      logEvent(analytics, 'onboarding_completed', {
        action: 'get_started',
      });
    }
    onComplete();

    // Dispatch event to trigger sign in button pulsating animation
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('onboardingCompleted'));
    }, 500);
  };

  return (
    <OverlayContainer $show={show}>
      <OnboardingContent $borderColor={mainColor} $show={show}>
        <OnboardingTitle>Welcome to {siteName}!</OnboardingTitle>
        <OnboardingText>
          The ultimate companion for the next big game, getting directions to
          sporting events and staying connected with your favorite team.
        </OnboardingText>
        {/* TODO: Need to improve text and pull from site data description or base it off what features are available, ex downkount has favorites but bigbluetime does not */}
        {/* <OnboardingText>
          Sign in to select your favorite sports teams, recieve game
          notifications and unlock personalized features!
        </OnboardingText> */}
        <OnboardingButton
          $bgColor={mainColor}
          onClick={handleGetStarted}
          style={{ backgroundColor: mainColor || '#ff3366' }}
        >
          Get Started
        </OnboardingButton>
      </OnboardingContent>
    </OverlayContainer>
  );
};

OnboardingOverlay.propTypes = {
  onComplete: PropTypes.func.isRequired,
};

export default OnboardingOverlay;
